import React from "react";
import { Link } from "react-router-dom";
import {
    ArrowRight,
    Download,
    List,
    RefreshCw,
    Scale,
    Sparkles,
    Timer,
    Users,
    Wallet,
} from "lucide-react";

const QUICK_LINKS = [
    {
        to: "/e/tahkim-dosyalari",
        label: "Veri girişi",
        hint: "Hakem, başvuru no, notlar",
        icon: List,
    },
    {
        to: "/yeni/muvekkil-merkezi",
        label: "Müvekkil Merkezi",
        hint: "Dilekçe & checklist",
        icon: Users,
    },
    {
        to: "/e/odemeler",
        label: "Ödeme takibi",
        hint: "Tahsilat & hakediş",
        icon: Wallet,
    },
];

export default function TahkimMerkezHero({
    loading,
    onRefresh,
    onExport,
    onRaporTab,
    toplam,
    onTahkimTab,
}) {
    return (
        <header className="relative overflow-hidden rounded-2xl border border-violet-500/25 bg-gradient-to-br from-[#121A2F] via-[#0f1424] to-[#1a1030] p-5 md:p-7 mb-6 shadow-[0_0_60px_rgba(139,92,246,0.08)]">
            <div
                className="pointer-events-none absolute -top-28 -right-20 h-64 w-64 rounded-full bg-violet-600/15 blur-3xl"
                aria-hidden
            />
            <div
                className="pointer-events-none absolute -bottom-24 -left-16 h-52 w-52 rounded-full bg-[#D4AF37]/12 blur-3xl"
                aria-hidden
            />
            <div
                className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-40 w-[80%] rounded-full bg-[#8b1f2f]/8 blur-3xl"
                aria-hidden
            />

            <div className="relative flex flex-col xl:flex-row xl:items-start xl:justify-between gap-6">
                <div className="max-w-2xl">
                    <div className="inline-flex items-center gap-2 rounded-full border border-violet-400/35 bg-violet-500/10 px-3 py-1 text-[10px] uppercase tracking-[0.22em] text-violet-200 mb-3">
                        <Scale className="h-3.5 w-3.5 text-[#D4AF37]" />
                        Gelişmiş Operasyon Modülü
                    </div>
                    <h1 className="font-display text-2xl md:text-4xl text-white tracking-tight flex flex-wrap items-center gap-3">
                        Tahkim Merkezi
                        {toplam != null && (
                            <span className="text-base md:text-lg font-mono font-normal text-violet-300/90 border border-violet-500/30 rounded-lg px-2.5 py-0.5">
                                {toplam} dosya
                            </span>
                        )}
                    </h1>
                    <p className="text-sm text-slate-400 mt-2 leading-relaxed max-w-xl">
                        Kanban süreç yönetimi, ödeme hatırlatmaları, ön tahkim otomasyonu ve toplu
                        işlemler — STK tahkim dosyalarınız tek komuta merkezinde.
                    </p>
                    <div className="flex flex-wrap gap-2 mt-4">
                        <button
                            type="button"
                            onClick={() => onTahkimTab?.("basvuru_asamasi")}
                            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs border border-cyan-500/35 bg-cyan-500/10 text-cyan-200 hover:bg-cyan-500/20 transition"
                        >
                            <List className="h-3.5 w-3.5" />
                            Başvuru &amp; Sürükle-Bırak
                            <ArrowRight className="h-3 w-3 opacity-60" />
                        </button>
                        <button
                            type="button"
                            onClick={() => onTahkimTab?.("on_tahkim")}
                            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs border border-sky-500/35 bg-sky-500/10 text-sky-200 hover:bg-sky-500/20 transition"
                        >
                            <Timer className="h-3.5 w-3.5" />
                            Ön Tahkim Komuta
                            <ArrowRight className="h-3 w-3 opacity-60" />
                        </button>
                        <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs border border-white/10 text-slate-500">
                            <Sparkles className="h-3.5 w-3.5 text-[#D4AF37]/70" />
                            Sigorta ↔ tahkim senkron
                        </span>
                    </div>
                </div>

                <div className="flex flex-col gap-3 shrink-0 min-w-[200px]">
                    <div className="flex flex-wrap gap-2">
                        <button
                            type="button"
                            onClick={onRefresh}
                            disabled={loading}
                            className="inline-flex items-center gap-1.5 h-9 px-3 rounded-lg border border-violet-500/35 bg-violet-500/10 text-sm text-violet-100 hover:bg-violet-500/20 disabled:opacity-50"
                        >
                            <RefreshCw
                                className={`h-4 w-4 ${loading ? "animate-spin" : ""}`}
                            />
                            Yenile
                        </button>
                        <button
                            type="button"
                            onClick={onExport}
                            className="inline-flex items-center gap-1.5 h-9 px-3 rounded-lg border border-white/10 text-sm text-slate-300 hover:bg-white/5"
                        >
                            <Download className="h-4 w-4" />
                            CSV
                        </button>
                        <button
                            type="button"
                            onClick={() => onRaporTab?.()}
                            className="inline-flex items-center gap-1.5 h-9 px-3 rounded-lg border border-[#D4AF37]/40 bg-[#D4AF37]/15 text-sm text-[#F3E5AB] hover:bg-[#D4AF37]/25 font-semibold"
                        >
                            <Download className="h-4 w-4" />
                            PDF Raporlar
                        </button>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-3 xl:grid-cols-1 gap-2">
                        {QUICK_LINKS.map((l) => (
                            <Link
                                key={l.to}
                                to={l.to}
                                className="group flex items-center gap-2.5 rounded-xl border border-white/10 bg-[#0B0F19]/60 px-3 py-2.5 hover:border-[#D4AF37]/35 hover:bg-[#D4AF37]/5 transition"
                            >
                                <l.icon className="h-4 w-4 text-[#D4AF37] shrink-0" />
                                <div className="min-w-0">
                                    <div className="text-xs font-semibold text-slate-200 group-hover:text-[#F3E5AB]">
                                        {l.label}
                                    </div>
                                    <div className="text-[10px] text-slate-500 truncate">
                                        {l.hint}
                                    </div>
                                </div>
                                <ArrowRight className="h-3 w-3 text-slate-600 group-hover:text-[#D4AF37] ml-auto shrink-0" />
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </header>
    );
}
